import gql from 'graphql-tag';

export const GET_CELL_BASES = gql`
    query (
        $golf_group_code: String
        $golf_code: String
    ){
        getCellBases (
            golf_group_code: $golf_group_code
            golf_code: $golf_code
        ) {
            CellBases {
                id
                course_name
                course_code
                play_date_start
                play_date_valid
                play_time_start
                play_time_valid
                interval
                updated_at
            }
        }
    }
`;

export const GET_CELL_BASE = gql`
    query (
        $id: ID!
    ){
        getCellBaseDetail(
            id: $id
        ){
            golf_code
            course_name
            course_code
            play_date_start
            play_date_valid
            play_time_start
            play_time_valid
            interval
        }
    }
`;

export const CREATE_CELL_BASES = gql`
    mutation(
        $golf_group_code:  String!
        $golf_code:        String!
        $course_code:      String!
        $play_date_start:  String!
        $play_date_valid:  String!
        $play_time_start:  String!
        $play_time_valid:  String!
        $interval:         String!
    ){
        createCellBases(
            golf_group_code:    $golf_group_code
            golf_code:    $golf_code
            course_code:    $course_code
            play_date_start:    $play_date_start
            play_date_valid:    $play_date_valid
            play_time_start:    $play_time_start
            play_time_valid:    $play_time_valid
            interval:    $interval
        ) {
            result
        }
    }
`;

export const UPDATE_CELL_BASES = gql`
    mutation(
        $golf_group_code:  String!
        $golf_code:        String!
        $course_code:      String!
        $play_date_start:  String!
        $play_date_valid:  String!
        $play_time_start:  String!
        $play_time_valid:  String!
        $interval:         String!
        $id: ID!
    ){
        updateCellBases(
            golf_group_code:    $golf_group_code
            golf_code:    $golf_code
            course_code:    $course_code
            play_date_start:    $play_date_start
            play_date_valid:    $play_date_valid
            play_time_start:    $play_time_start
            play_time_valid:    $play_time_valid
            interval:    $interval
            id: $id
        ) {
            result
        }
    }
`;

export const CREATE_CELL_LINKS = gql`
    mutation(
        $golf_group_code:  String!
        $golf_code:        String!
        $course_code:      String!
        $play_date_start:  String!
        $play_date_valid:  String!
        $play_time_start:  String!
        $play_time_valid:  String!
        $interval:         String!
    ){
        createCellLinks(
            golf_group_code:    $golf_group_code
            golf_code:    $golf_code
            course_code:    $course_code
            play_date_start:    $play_date_start
            play_date_valid:    $play_date_valid
            play_time_start:    $play_time_start
            play_time_valid:    $play_time_valid
            interval:    $interval
        ) {
            result
        }
    }
`;

export const DELETE_CELL_BASES = gql`
    mutation (
        $id: ID!
    ){
        deleteCellBases(
            id: $id
        ) {
            result
        }
    }
`;
